import swal from 'sweetalert';
import { EventDispatcher } from 'three';
import 'dotenv/config'

// let user = "vw-user@hegias.com";
// let password = "rP-zRSmQvZc2Ucip"
export class ApiCalls extends EventDispatcher{
    constructor(){
        super();
        
        let axios = require('axios');
        this.axios = axios;
        this.baseUrl = `https://app.${process.env.REACT_APP_BASE_URL}`;
    }

    getToken(){
        if(localStorage.getItem("authToken") === undefined || localStorage.getItem("authToken")===null){
            return undefined;
        }
        return JSON.parse(localStorage.getItem("authToken")).token;
    }

    getExpirationDate(){
        if(localStorage.getItem("authToken")=== undefined){
            return undefined;
        }
        return JSON.parse(localStorage.getItem("authToken")).expirationDate;
    }

    refresh(){
        let token = JSON.parse(localStorage.getItem("authToken")).refreshToken;

        this.axios.post(this.baseUrl+"/api/v3/auth/token/refresh", {refreshToken: token})
        .then((res)=>{
            console.log(res);
            /*let authenticationToken = res.data.message.token;
            let date = new Date();
            date.setDate(date.getDate()+7);
            localStorage.setItem("authToken", JSON.stringify({token: authenticationToken, 
                expirationDate: date,
                refreshToken: res.data.message.refreshToken
            }));*/
        })
        .catch((e)=>{
            console.log(e);
        })
    }

    getBearerToken(){
        let username = document.getElementById("username");
        let password = document.getElementById("password");
    
        // get authentication token
        let authUrl = this.baseUrl + "/api/v3/auth/login";
        let body = {
            "email": username.value,
            "password": password.value
        }
    
        // clear inputs
        username.value = "";
        password.value = "";
    
        this.axios.post(authUrl, body)
        .then((res) => {
            console.log(res);
            let authenticationToken = res.data.message.token;
            let date = new Date();
            date.setDate(date.getDate()+30);
            localStorage.setItem("authToken", JSON.stringify({token: authenticationToken, 
                expirationDate: date,
                refreshToken: res.data.message.refreshToken
            }));
            swal({
                buttons: false,
                icon:"success",
                text:"logged in",
                timer: 2000
            });
            this.dispatchEvent({type: "EVENT_LOG_IN"});
        })
        .catch((err) => {
            swal({
                buttons: false,
                icon:"error",
                text:"Invalid credential",
                timer: 3000
            });
        });
    }
    
    getOrgId(evt, value){
        // getORgs
        let orgsUrl = this.baseUrl + "/api/v3/organizations?limit=100&page=1&filters[roles]=owner&filters[roles]=admin&filters[roles]=senior&filters[roles]=junior";
        let header = { 'Authorization': 'Bearer ' + this.getToken() };
        //get orgid
        this.axios.get(orgsUrl, { headers: header })
        .then((res) => {
            let orgId = "605da587183b190484af53a4";//res.data.results[0].id;
            this.getProjects(this.getToken(), orgId, evt.gltf, value);
        })
        .catch((err) => {
            console.log("failed to get the orgId");
        });
    }

    async getOrgList(){
        let orgsUrl = this.baseUrl + "/api/v3/organizations?limit=100&page=1&filters[roles]=owner&filters[roles]=admin&filters[roles]=senior&filters[roles]=junior";
        let header = { 'Authorization': 'Bearer ' + this.getToken() };
        //get orgid
        const result = await this.axios.get(orgsUrl, { headers: header })
        return result.data.results;
    }

    async getProjectsList(orgId){
        //get projects
        let projectUrl = this.baseUrl + "/api/v3/projects?limit=1000&page=1&sort=-meta.tsModified";
        let projectHeader = { 'Authorization': 'Bearer ' + this.getToken(), 'x-org': orgId };
        const result = await this.axios.get(projectUrl, { headers: projectHeader })
        let projects = result.data.results;

        return projects;

    }

    getProjects(authToken, orgId, data, sceneName) {
        //get projects
        let projectUrl = this.baseUrl + "/api/v3/projects?limit=1000&page=1&sort=-meta.tsModified";
        let projectHeader = { 'Authorization': 'Bearer ' + authToken, 'x-org': orgId };
        this.axios.get(projectUrl, { headers: projectHeader })
            .then((res) => {
                //console.log(res.data.results);
    
                let projects = res.data.results;
                let found = false;
                let foundProject;
                projects.forEach((p) => {
                    if (p.meta.name === "trial-import") {
                        found = true;
                        foundProject = p;
                    }
                });
    
                // if found upload scene
                //console.log(foundProject)
                if (found) {
                    this.createScene(authToken, orgId, foundProject._id, data, foundProject.shortid, sceneName);
                } else {
                   this.createProject(authToken, orgId);
                }
            })
            .catch((err) => {
                console.log("failed to get projects");
                console.log(err);
            })
    }

    async getProject(authToken,orgId, projectId){
        let projectUrl = this.baseUrl + "/api/v3/projects/"+projectId;
        let projectHeader = { 'Authorization': 'Bearer ' + authToken, 'x-org': orgId };
        const projects = await this.axios.get(projectUrl, { headers: projectHeader })

        return projects['data'];
    }

    async getOrgFromID(orgId){
        let orgsUrl = this.baseUrl + "/api/v3/organizations/"+orgId;
        let header = { 'Authorization': 'Bearer ' + this.getToken() };
        //get orgid
        const result = await this.axios.get(orgsUrl, { headers: header })
        let org = result['data']; //['meta']['subdomain'];
        console.log("getOrgFromID");
        console.log(org);
        return org;

    }

    createProject(authToken, orgId) {
        //create project
        let projectCreationRoute = this.baseUrl + "/api/v3/projects/";
        let fields = {
            'meta.name': "trial-import",
            'meta.description': "",
            'meta.tags': "",
            'meta.thumbnail': ""
        }
        let pcHeaders = { 'Authorization': 'Bearer ' + authToken, 'x-org': orgId };
        this.axios.post(projectCreationRoute, fields, { headers: pcHeaders })
            .then((res) => {
                console.log(res);
            })
            .catch((err) => {
                console.log("failed to create project");
            })
    }

    async createSceneOverload(orgId, projectId, data, sceneName) {
        console.log("create scene overload");
        const authToken = this.getToken();

        const project = await this.getProject(authToken, orgId, projectId);
        console.log("createSceneOverload -- project");
        console.log(project);
        const shortId = project['shortid'];
        this.createScene(authToken, orgId, projectId, data, shortId, sceneName);

    }
    
    async createScene( authToken, orgId, Id, data, shortId, sceneName) {
        console.log("project already exists");
        //console.log(Id);
        let uploadSceneUrl = this.baseUrl + "/api/v3/upload/projects/" + Id + "/scenes/";
        let suHeaders = {
            'Authorization': 'Bearer ' + authToken,
            'x-org': orgId,
            'Content-Type': "application/json"
        }
        
        let options = { "scale":{"value":1},
                        "decimateFactor":{"value":20},
                        "useHegiasMaterials":{"value":true},
                        "useLibraryObjects":{"value":true},
                        "centerGeometry":{"value":true},
                        "categories":{"value":true},
                        "runShaderMap":{"value":false},
                        "doubleSided":{"value":true},
                        "generateUVs":{"value":true},
                        "smoothShading":{"value":true}
                    }
        let fileToSend = new File([data], "scene.glb");
    
        let fd = new FormData();
            fd.append('filename', "check.glb");
            fd.append('meta.name', sceneName);
            fd.append('meta.description', "description");
            fd.append('object', fileToSend);
            fd.append('options', JSON.stringify(options));
        const org = await this.getOrgFromID(orgId); 
        const orgSubdomain = org['meta']['subdomain'];
        this.axios.post(uploadSceneUrl, fd, { headers: suHeaders})
        .then((res)=>{
            //console.log(res);
            const newBaseURL = this.baseUrl.replace("app", orgSubdomain);
            let link = document.createElement('a');
            link.innerHTML = "Click here to go to the scene";
            link.setAttribute('href', newBaseURL+"/projects/"+shortId+"/scenes/");
            link.setAttribute('target', "_blank");
            swal({
                icon:"success", 
                text:"Scene uploaded successfully",
                // // timer: 5000,
                content: link
            });
        })
        .catch((err)=>{
            console.log("failed to create scene");
            console.log(err);
            swal({
                icon:"error", 
                text:"Something went wrong",
                timer: 5000
            });
        });
    }
}
